import { createElement, Fragment } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { MenuGroup, MenuItem, MenuItemsChoice, ToolbarDropdownMenu } from '@wordpress/components';
import { __, sprintf } from '@wordpress/i18n';
import { decodeEntities } from '@wordpress/html-entities';
import { addQueryArgs } from '@wordpress/url';
import { forwardRef, useCallback, useMemo } from '@wordpress/element';
/**
 * Internal dependencies
 */

import useNavigationMenu from '../use-navigation-menu';
import useNavigationEntities from '../use-navigation-entities';

function NavigationMenuSelector(_ref, forwardedRef) {
  let {
    currentMenuId,
    onSelect,
    onCreateNew,
    showManageActions = false,
    actionLabel,
    toggleProps = {}
  } = _ref;

  /* translators: %s: The name of a menu. */
  const createActionLabel = __("Create from '%s'");

  actionLabel = actionLabel || createActionLabel;
  const {
    menus: classicMenus
  } = useNavigationEntities();
  const {
    navigationMenus,
    canUserCreateNavigationMenu,
    canUserUpdateNavigationMenu,
    canSwitchNavigationMenu
  } = useNavigationMenu();
  const handleSelect = useCallback(_onClose => selectedId => {
    _onClose();

    onSelect(navigationMenus === null || navigationMenus === void 0 ? void 0 : navigationMenus.find(post => post.id === selectedId));
  }, [navigationMenus]);
  const handleSelectClassic = useCallback((_onClose, menu) => () => {
    _onClose();

    onSelect(menu);
  }, []);
  const menuChoices = useMemo(() => {
    return (navigationMenus === null || navigationMenus === void 0 ? void 0 : navigationMenus.map(_ref2 => {
      let {
        id,
        title
      } = _ref2;
      const label = decodeEntities(title.rendered);
      return {
        value: id,
        label,
        ariaLabel: sprintf(actionLabel, label)
      };
    })) || [];
  }, [navigationMenus]);
  const hasNavigationMenus = !!(navigationMenus !== null && navigationMenus !== void 0 && navigationMenus.length);
  const hasClassicMenus = !!(classicMenus !== null && classicMenus !== void 0 && classicMenus.length);
  const showNavigationMenus = !!canSwitchNavigationMenu;
  const showClassicMenus = !!canUserCreateNavigationMenu;
  const hasManagePermissions = canUserCreateNavigationMenu || canUserUpdateNavigationMenu; // Show the selector if:
  // - has switch or create permissions and there are block or classic menus.
  // - user has create or update permisisons and component should show the menu actions.

  const showSelectMenus = (canSwitchNavigationMenu || canUserCreateNavigationMenu) && (hasNavigationMenus || hasClassicMenus) || hasManagePermissions && showManageActions;

  if (!showSelectMenus) {
    return null;
  }

  return createElement(ToolbarDropdownMenu, {
    ref: forwardedRef,
    label: __('Select Menu'),
    text: __('Select Menu'),
    icon: null,
    toggleProps: toggleProps
  }, _ref3 => {
    let {
      onClose
    } = _ref3;
    return createElement(Fragment, null, showNavigationMenus && hasNavigationMenus && createElement(MenuGroup, {
      label: __('Menus')
    }, createElement(MenuItemsChoice, {
      value: currentMenuId,
      onSelect: handleSelect(onClose),
      choices: menuChoices
    })), showClassicMenus && hasClassicMenus && createElement(MenuGroup, {
      label: __('Classic Menus')
    }, classicMenus === null || classicMenus === void 0 ? void 0 : classicMenus.map(menu => {
      const label = decodeEntities(menu.name);
      return createElement(MenuItem, {
        onClick: handleSelectClassic(onClose, menu),
        key: menu.id,
        "aria-label": sprintf(createActionLabel, label)
      }, label);
    })), showManageActions && hasManagePermissions && createElement(MenuGroup, {
      label: __('Tools')
    }, canUserCreateNavigationMenu && createElement(MenuItem, {
      onClick: onCreateNew
    }, __('Create new menu')), createElement(MenuItem, {
      href: addQueryArgs('edit.php', {
        post_type: 'wp_navigation'
      })
    }, __('Manage menus'))));
  });
}

export default forwardRef(NavigationMenuSelector);
//# sourceMappingURL=navigation-menu-selector.js.map